import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import {
  IonButton,
  IonGrid,
  IonImg,
  IonRow,
  IonText,
} from '@ionic/angular/standalone';
import { Subscription, take } from 'rxjs';
import { ISearchTransactionResponse } from '../interfaces/searchTransactionResponse';
import { ObdService } from '../services/obd.service';
import { StoreService } from '../services/store.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [IonButton, IonGrid, IonRow, IonText, IonImg],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  urlId: string | null = '';
  isButtonBlocked: boolean = false;
  showUrlError: boolean = false;
  verificationAlreadyRequested: boolean = false;

  loading: boolean = true;

  LOGO_URL: string = '';

  showFirmaDigitalHome: boolean = true;
  firmaYOnboarding: boolean = false;

  private subscriptions = new Subscription();

  constructor(
    private _router: Router,
    private _obdService: ObdService,
    private _storeService: StoreService,
    private _actRoute: ActivatedRoute,
    private _loadingCtrl: LoadingController,
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this._storeService.logoImageUrl$.subscribe((resp) => (this.LOGO_URL = resp)),
    );

    this._storeService.transactionId$.pipe(take(1)).subscribe((currentUUID) => {
      if (currentUUID && this._checkIsAValidUUID(currentUUID)) {
        this.urlId = currentUUID;
        this._showLoading();
        return;
      }

      this.subscriptions.add(
        this._actRoute.params.subscribe((params) => {
          this.showUrlError = false;
          this.urlId = params['id'];
          if (!this.urlId || !this._checkIsAValidUUID(this.urlId)) {
            this.showFirmaDigitalHome = false;
            this.loading = false;
            return;
          }
          this._storeService.transactionId$.next(this.urlId);
          this._showLoading();
        }),
      );
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  navigateToNextStep(): void {
    if (this.showFirmaDigitalHome || !this.firmaYOnboarding) {
      this._router.navigate(['contract']);
      return;
    }
    this._router.navigate(['chat']);
  }

  private async _showLoading() {
    if (this.verificationAlreadyRequested) return;

    const loading: HTMLIonLoadingElement = await this._loadingCtrl.create({
      message: 'Securizando comunicación',
    });
    loading.present();
    this._securalizeData(loading);
  }

  private _securalizeData(loading: HTMLIonLoadingElement): void {
    if (!this.urlId) return;
    this._obdService.validateUrlId(this.urlId).subscribe({
      next: (response) => {
        if (response.firma && response.selfie === null) {
          this.verificationAlreadyRequested = true;
          if (response.solo_firma) {
            this._storeService.onlySignOperation.next(true);
          } else {
            this.firmaYOnboarding = response.motor_riesgo;
          }
          loading.dismiss();
          this.loading = false;
          this._storeService.searchTransactionResponse$.next(response);
          this._toggleBienvenida(response);
        } else {
          this.showUrlError = true;
          loading.dismiss();
          this.loading = false;
        }
      },
      error: (error: any) => {
        console.error(error);
        this.showUrlError = true;
        loading.dismiss();
        this.loading = false;
      },
    });
  }

  private _checkIsAValidUUID(value: string): boolean {
    const uuidRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(value);
  }

  private _toggleBienvenida(response: ISearchTransactionResponse): void {
    if (response.contrato && response.solo_firma) {
      this.showFirmaDigitalHome = true;
    } else {
      this.showFirmaDigitalHome = false;
      this._storeService.onlySignOperation.next(false);
    }
  }
}
